<template>
    <div class="filter-criteria-container">
        <div class="filter-label">
            {{ $t('unlayerBuilder.templateSelection.filterBy') }}
        </div>

        <div class="filter-criteria unlayer-email-broadcast-gallery-filter-criteria">
            <DsMultiselect
                bind-value-only
                data-qa="template-selection-filter-industry"
                :value="industry"
                :options="industryOptions"
                :placeholder="$t('unlayerBuilder.templateSelection.dropdownInput.industry.placeholder')"
                class="filter-select"
                @input="handleIndustryChange"
            />
        </div>

        <div class="filter-criteria unlayer-email-broadcast-gallery-filter-criteria">
            <DsMultiselect
                bind-value-only
                data-qa="template-selection-filter-usage"
                :value="usage"
                :options="usageOptions"
                :placeholder="$t('unlayerBuilder.templateSelection.dropdownInput.usage.placeholder')"
                class="filter-select"
                @input="handleUsageChange"
            />
        </div>
    </div>
</template>

<script>
export const ALL_VALUE = 'View All';

export default {
    props: {
        industry: String,
        usage: String,
    },

    computed: {
        industryOptions() {
            const industries = [
                { value: null, label: this.$t('unlayerBuilder.templateSelection.dropdown.viewAll') },
                { value: 'Automotive', label: this.$t('unlayerBuilder.templateSelection.dropdown.automotive') },
                { value: 'Beauty & Personal Care', label: this.$t('unlayerBuilder.templateSelection.dropdown.beautyPersonalCare') },
                { value: 'Business', label: this.$t('unlayerBuilder.templateSelection.dropdown.business') },
                { value: 'Computers & Internet', label: this.$t('unlayerBuilder.templateSelection.dropdown.computersInternet') },
                { value: 'Education', label: this.$t('unlayerBuilder.templateSelection.dropdown.education') },
                { value: 'Electronics', label: this.$t('unlayerBuilder.templateSelection.dropdown.electronics') },
                { value: 'Fashion', label: this.$t('unlayerBuilder.templateSelection.dropdown.fashion') },
                { value: 'Finance', label: this.$t('unlayerBuilder.templateSelection.dropdown.finance') },
                { value: 'Food & Beverage', label: this.$t('unlayerBuilder.templateSelection.dropdown.food.beverage') },
                { value: 'Healthcare', label: this.$t('unlayerBuilder.templateSelection.dropdown.healthcare') },
                { value: 'Human Resources', label: this.$t('unlayerBuilder.templateSelection.dropdown.humanResources') },
                { value: 'Manufacturing', label: this.$t('unlayerBuilder.templateSelection.dropdown.manufacturing') },
                { value: 'Marketing', label: this.$t('unlayerBuilder.templateSelection.dropdown.marketing') },
                { value: 'Media & Entertainment', label: this.$t('unlayerBuilder.templateSelection.dropdown.mediaEntertainment') },
                { value: 'News, Blog & Magazines', label: this.$t('unlayerBuilder.templateSelection.dropdown.newsBlogMagazines') },
                { value: 'Non Profit', label: this.$t('unlayerBuilder.templateSelection.dropdown.nonprofit') },
                { value: 'Others', label: this.$t('unlayerBuilder.templateSelection.dropdown.others') },
                { value: 'Pets and Animal Care', label: this.$t('unlayerBuilder.templateSelection.dropdown.petsAnimalCare') },
                { value: 'Photography', label: this.$t('unlayerBuilder.templateSelection.dropdown.photography') },
                { value: 'Real Estate', label: this.$t('unlayerBuilder.templateSelection.dropdown.realEstate') },
                { value: 'Sales', label: this.$t('unlayerBuilder.templateSelection.dropdown.sales') },
                { value: 'Sports', label: this.$t('unlayerBuilder.templateSelection.dropdown.sports') },
                { value: 'Transport', label: this.$t('unlayerBuilder.templateSelection.dropdown.transport') },
                { value: 'Travel & Leisure', label: this.$t('unlayerBuilder.templateSelection.dropdown.travelLeisure') },
            ];

            return industries.map((industry) => {
                return {
                    value: industry.value,
                    label: industry.label,
                };
            });
        },

        usageOptions() {
            const usages = [
                { value: null, label: this.$t('unlayerBuilder.templateSelection.dropdown.viewAll') },
                { value: 'Abandoned Cart', label: this.$t('unlayerBuilder.templateSelection.dropdown.abandonedCart') },
                { value: 'Activation', label: this.$t('unlayerBuilder.templateSelection.dropdown.activation') },
                { value: 'Confirmation', label: this.$t('unlayerBuilder.templateSelection.dropdown.confirmation') },
                { value: 'Ecommerce', label: this.$t('unlayerBuilder.templateSelection.dropdown.ecommerce') },
                { value: 'Events', label: this.$t('unlayerBuilder.templateSelection.dropdown.events') },
                { value: 'Fundraising', label: this.$t('unlayerBuilder.templateSelection.dropdown.fundraising') },
                { value: 'Newsletter', label: this.$t('unlayerBuilder.templateSelection.dropdown.newsletter') },
                { value: 'Notification', label: this.$t('unlayerBuilder.templateSelection.dropdown.notification') },
                { value: 'Product Launch', label: this.$t('unlayerBuilder.templateSelection.dropdown.product.launch') },
                { value: 'Product Promotion', label: this.$t('unlayerBuilder.templateSelection.dropdown.product.promotion') },
                { value: 'Thank You', label: this.$t('unlayerBuilder.templateSelection.dropdown.thankYou') },
                { value: 'Transactional', label: this.$t('unlayerBuilder.templateSelection.dropdown.transactional') },
            ];

            return usages.map((usage) => {
                return {
                    value: usage.value,
                    label: usage.label,
                };
            });
        },
    },

    methods: {
        handleIndustryChange(value) {
            this.$emit('update:industry', value);
        },

        handleUsageChange(value) {
            this.$emit('update:usage', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.filter-criteria-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.filter-label {
    color: $color-ink;
}

.filter-criteria {
    width: px-to-rem(300);
    margin-left: $spacing-200;
}

.filter-select {
    margin-bottom: 0;
}
:deep(.dropdown-menu) {
    z-index: 4;
}
</style>

<style lang="scss">
.unlayer-email-broadcast-gallery-filter-criteria {
    & label {
        padding-top: 0;
    }
}
</style>
